import { render, staticRenderFns } from "./customer-foldout.vue?vue&type=template&id=e6a19722&"
import script from "./customer-foldout.vue?vue&type=script&lang=js&"
export * from "./customer-foldout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports